import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-manage-profile',
  templateUrl: './default-manage-profile.component.html',
  styleUrls: ['./default-manage-profile.component.scss']
})
export class DefaultManageProfileComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
